import {
  Modal,
  ModalOverlay,
  ModalContent,
  HStack,
  Spinner,
  Text,
} from "@chakra-ui/react";

export function LoadingOverlayModal({ disclosure, message }) {
  return (
    <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent bg="transparent" boxShadow="none" display="flex" justifyContent="center" alignItems="center">
        {/* Choose either Progress or CircularProgress */}
        {/* <Progress value={progressValue} size="lg" hasStripe isAnimated /> */}
        <HStack>
            <Spinner />
            <Text>{message || "Loading..."}</Text>
        </HStack>
      </ModalContent>
    </Modal>
  );
}